import { GRAPHQL_AUTHENTICATION } from "~/constants/url";
import { BaseGraphQL } from "~/services/baseGraphQL";
import { UserCompanyInfo } from "~/types/authentication";
import { JsonResponseType } from "~/types/jsonResponseType";

const authenticationGraph = BaseGraphQL({
  baseUrl: GRAPHQL_AUTHENTICATION,
});

export const renewToken = async () => {
  const query = `
  query {
      authenticate {
        renewToken {
          data {
            userCompaniesInfo {
              companyId
              tokenObject {
                token
              }
            }
          }
          messageCode
          succeed
        }
      }
    }
  `;

  return await authenticationGraph<
    UserCompanyInfo,
    {
      authenticate: { renewToken: JsonResponseType<UserCompanyInfo> };
    }
  >(
    {
      action: "UserGraphQL",
      query,
      variables: {},
    },
    (input) => input.authenticate.renewToken,
  );
};
